import React from 'react';
import { useTheme } from '@material-ui/core';
import { SparrowMark } from './SparrowMark';

/** Collapsed-sidebar logo: the brand mark alone, tinted to the brand teal. */
const LogoIcon = () => {
  const theme = useTheme();
  return <SparrowMark size={28} color={theme.palette.primary.main} />;
};

export default LogoIcon;
